import { createSlice } from '@reduxjs/toolkit'
import { setIsClearingReduxFormState } from 'state/ui'

const initialState = {
  filters: {
    customer: {
      name: 'Customer',
      value: '',
      path: 'supplier.displayName',
    },
    status: {
      name: 'Status',
      value: 'Open',
      path: 'status',
    },
  },
  duplicatePurchaseOrderId: '',
  isSetup: false,
}

export const purchaseOrderSlice = createSlice({
  name: 'purchaseOrder',
  initialState,
  reducers: {
    setPurchaseOrderFilter: (state, action) => {
      const { filter, value } = action.payload
      state.filters[filter].value = value
    },
    clearPurchaseOrderFilters: state => {
      state.filters = initialState.filters
    },
    setDuplicatePurchaseOrderId: (state, action) => {
      state.duplicatePurchaseOrderId = action.payload
    },
    clearDuplicatePurchaseOrderId: state => {
      state.duplicatePurchaseOrderId = initialState.duplicatePurchaseOrderId
    },
    setIsSetup: (state, action) => {
      state.isSetup = action.payload
    },
    clearIsSetup: state => {
      state.isSetup = initialState.isSetup
    },
  },
  extraReducers: builder => {
    builder.addCase(setIsClearingReduxFormState, (state, action) => {
      if (action.payload) {
        state.filters = initialState.filters
        state.duplicatePurchaseOrderId = initialState.duplicatePurchaseOrderId
        state.isSetup = initialState.isSetup
      }
    })
  },
})

export const {
  setPurchaseOrderId,
  clearPurchaseOrderId,
  setPurchaseOrderFilter,
  clearPurchaseOrderFilters,
  setDuplicatePurchaseOrderId,
  clearDuplicatePurchaseOrderId,
  setIsSetup,
  clearIsSetup,
} = purchaseOrderSlice.actions

export default purchaseOrderSlice.reducer
